import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getContractorJobList = createAsyncThunk(
  "contractorJobList/getContractorJobList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/get_contractor_Job`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contractorJobListingSlice = createSlice({
  name: "contractorJobList",
  initialState: {
    loading: false,
    contractorJobData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractorJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorJobList.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorJobData = action.payload;
      })
      .addCase(getContractorJobList.rejected, (state, action) => {
        state.loading = false;
        state.contractorJobData = action.payload;
        state.error = action.payload;
      });
  },
});

export default contractorJobListingSlice.reducer;
